/**
 * Client-side site mapping from environment name to site ID
 * Based on Paytient data reach mapping (mirrors backend siteMapping.js)
 */

const SITE_MAPPING = {
  aah: 136,
  accredo: 102,
  "advocate-atrium": 263,
  alivia: 120,
  alliancerx: 57,
  allinahealth: 83,
  anderson: 72,
  archbold: 128,
  "augusta-oncology": 22,
  "ballad-research": 135,
  balladhealth: 80,
  bayhealth: 127,
  beebe: 275,
  bhsf: 125,
  biotek: 32,
  bronson: 139,
  brookwell: 116,
  bsmh: 111,
  carti: 1,
  cbci: 104,
  centerwell: 58,
  dominican: 112,
  emory: 271,
  englewood: 67,
  fairview: 47,
  fcs: 63,
  fmol: 41,
  froedtert: 103,
  gbmc: 270,
  genoa: 119,
  hartford: 273,
  hemonc: 99,
  hmh: 265,
  hog: 21,
  ingalls: 70,
  iuhealth: 118,
  ivxhealth: 122,
  kabafusion: 86,
  kumc: 110,
  lakeregion: 73,
  lancaster: 27,
  lcmc: 95,
  lindenberg: 30,
  "maxor-cp": 130,
  "maxor-sp": 132,
  medstar: 267,
  mercycedar: 264,
  metrohealth: 45,
  moffitt: 108,
  msmc: 33,
  munson: 8,
  necs: 9,
  novant: 117,
  novartis: 121,
  oakstead: 87,
  onslow: 100,
  optuminfusion: 106,
  optumrx: 55,
  osf: 62,
  owensboro: 76,
  palmetto: 68,
  peacehealth: 137,
  pikeville: 64,
  primetherapeutics: 93,
  prohealth: 59,
  "prosper-infusion": 53,
  "providence-central": 266,
  "providence-credena": 77,
  "providence-northern-california": 49,
  "providence-southern-california": 35,
  "providence-swedish": 15,
  pureinfusion: 61,
  "rio-grande": 66,
  seacoast: 12,
  sfhs: 105,
  sih: 97,
  sjchs: 123,
  somc: 13,
  spartanburg: 91,
  sph: 82,
  ssmh: 133,
  stals: 140,
  stonybrook: 65,
  "suny-upstate": 74,
  sweetwater: 98,
  thomashealth: 114,
  twelvestone: 69,
  ucdavis: 109,
  "uci-research": 81,
  ucirvine: 274,
  ucsd: 107,
  ucsf: 124,
  umc: 115,
  "umichigan-research": 101,
  "university-hospitals": 44,
  vca: 46,
  "vytlone-cp": 269,
  "vytlone-sp": 268,
  walgreens: 26,
  "walgreens-retail": 52,
  washingtonhealth: 272,
  ynhhs: 92
};

/**
 * Get site ID for current environment (client-side version)
 * @param {string} environment - Environment name from store
 * @returns {number|string} Site ID or fallback value
 */
export const getSiteId = (environment) => {
  if (!environment || environment === "dev" || environment.includes("dev_staging")) {
    return "dev";
  }

  if (environment.startsWith("tde")) {
    return "mars";
  }

  const cleanEnv = environment.replace("_staging", "");

  const siteId = SITE_MAPPING[cleanEnv];

  if (siteId) {
    return siteId;
  }

  switch (cleanEnv) {
    case "mars":
      return "mars";
    case "orion":
      return "orion";
    default:
      return cleanEnv;
  }
};

/**
 * Format patient ID as siteID_patientID
 * @param {string|number} patientId - Raw patient ID
 * @param {string} environment - Environment name from store
 * @returns {string} Formatted patient ID
 */
export const formatPatientIdWithSite = (patientId, environment) => {
  const siteId = getSiteId(environment);
  return `${siteId}_${patientId}`;
};
